import { useQuery } from '@tanstack/react-query';
import { curriculumApi, ListOutcomesParams } from '../../services/api/curriculum';

/** Active CAPS Learning Outcomes for the current org's tenant.
 *
 * Outcomes are largely static -- once seeded for a school they rarely
 * change -- so we cache aggressively and re-use across the org's session
 * (search-as-you-type in the picker should not refetch).
 */
export const useLearningOutcomes = (params?: ListOutcomesParams) => {
  return useQuery({
    queryKey: ['curriculum', 'outcomes', params],
    queryFn: () => curriculumApi.listOutcomes({ is_active: true, ...params }),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

/** Active CAPS Learning Areas for the org -- used to group outcomes in
 * the picker. Same caching as outcomes for the same reason. */
export const useLearningAreas = () => {
  return useQuery({
    queryKey: ['curriculum', 'areas'],
    queryFn: () => curriculumApi.listAreas(),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};
